import { render } from "./NavCatHeader.vue?vue&type=template&id=0032a49f&scoped=true"
import script from "./NavCatHeader.vue?vue&type=script&lang=js"
export * from "./NavCatHeader.vue?vue&type=script&lang=js"

import "./NavCatHeader.vue?vue&type=style&index=0&id=0032a49f&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0032a49f"]])

export default __exports__